import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getData } from 'country-list';
import { AppConstants_settings } from '../AppConstants_Appsettings.enum';
import { environment } from '../../../environments/environment';

export interface Airport {
  airportCode: string;
  airportName: string;
  cityName: string;
  countryName: string;
  isNearby: boolean;
}

export interface PassengerCount {
  adult: number;
  child: number;
  infant: number;
}

export interface OriginDestination {
  from: string;
  to: string;
  departureDate: string;
}

export interface FlightSearchRequest {
  tripType: string;
  cabinClass: string;
  passengers: PassengerCount;
  originDestinations: OriginDestination[];
}

export interface FlightSearchResponse {
  success: boolean;
  data?: any;
  message?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.B2CAPI_URL;
  private commonUrl = environment.COMMON_URL;
  private emailUrl = environment.EMAIL_URL;
  private localBaseUrl = "http://localhost:5213/api/B2C/"; // Example local URL

  constructor(private http: HttpClient) { }

  searchAirports(query: string): Observable<Airport[]> {
    return this.http.get<Airport[]>(`${this.baseUrl}` + `Handler/GetAirports`, { params: { request: query } });
  }

  generateToken() {
    return this.http.get(`${this.baseUrl}Request/GetToken`);
  }

  flightRequest(payload: any) {
    return this.http.post(`${this.baseUrl}Request/GetAvailability`, payload);
  }

  flightResponse(resultId: string, isFirstRequest: boolean) {
    let params = new HttpParams().set('resultId', resultId).set('isFirstRequest', isFirstRequest.toString());
    return this.http.get(`${this.baseUrl}Response/GetResponse`, { params });
  }

  getFlightReservation(bookingRequest: any) {
    return this.http.post(`${this.baseUrl}Reservation/RevalidateFare`, bookingRequest);
  }

  getPaymentMethods(payload: any) {
    return this.http.post(`${this.baseUrl}PaymentMethods/GetPaymentMethods`, payload);
  }

  getCardCharges(payload: any) {
    return this.http.post(`${this.baseUrl}CardCharges/GetCharges`, payload);
  }

  verifyCard(payload: any) {
    return this.http.post(`${this.baseUrl}PaymentGateway/VerifyCard/verify-card`, payload);
  }

  submitBooking(bookingData: any, resultId: any, itnId: any, Channel: any, wegoClickId: any) {
    return this.http.post(`${this.baseUrl}Booking/SaveBooking`, bookingData, { params: { resultId: resultId, itnId: itnId, channel: Channel, wegoClickId: wegoClickId } });
  }

  saveCustomer(payload: any, companyId: any) {
    return this.http.post(`${this.baseUrl}Customer/CustomerData`, payload, { params: { companyId: companyId } });
  }

  confirmation(resId: any) {
    return this.http.get(`${this.baseUrl}Confirmation/GetBooking`, { params: { resultId: resId } });
  }

  Invoice(resId: any, compId: any) {
    return this.http.post(`${this.emailUrl}send-invoice?bookingId=${resId}&compId=${compId}`, {});
  }

  getCapture(pgCode: any, resId: any, companyId: any, orderRef: any) {
    return this.http.post(`${this.baseUrl}PaymentGateway/PGResponse/gateway/response/${pgCode}/${resId}/${companyId}`, { params: { ref: orderRef } });
  }

  E_Ticket(payload: any) {
    return this.http.post(`${this.emailUrl}print-eticket`, payload);
  }

  getSeatMap(payload: any) {
    return this.http.post(`${this.baseUrl}SeatMap/GetSeatMap`, payload);
  }

  getCountryList() {
    return getData();
  }

  getBookingAccess(data: any) {
    return this.http.post(`${this.baseUrl}GetBookingAccess/BookingAccess`, data);
  }

  signUp(userData: any) {
    return this.http.post(`${this.baseUrl}SignUp/UserSignUp`, userData);
  }

  signIn(userData: any) {
    return this.http.post(`${this.baseUrl}SignIn/UserSignIn`, userData);
  }

  updateProfile(userData: any) {
    return this.http.post(`${this.baseUrl}Profile/UpdateProfile`, userData);
  }

  updatePassword(userData: any) {
    return this.http.post(`${this.baseUrl}ForgetPassword/PasswordAction`, userData);
  }

  getCurrencyData(data: any) {
    return this.http.post(`${this.commonUrl}CompanyCurrency/CompanyCurrency?companyId=${data.companyId}`, {});
  }

  getBookings(payload: any) {
    return this.http.post(`${this.baseUrl}GetBooking/GetBookingDetails`, payload);
  }
  getBookingsDetails(payload: any) {
    return this.http.post(`${this.baseUrl}GetBooking/GetBookingData`, payload);
  }

  companySettings(payload: any) {
    return this.http.post(`${this.commonUrl}CompanySettings/CompanySettings?companyId=${payload}`, {});
  }

  cancelBooking(payload: any) {
    return this.http.post(`${this.emailUrl}cancelBooking`, payload);
  }

  newsLetter(payload: any) {
    return this.http.post(`${this.emailUrl}sendNewsletter`, payload);
  }

  contactUs(payload: any) {
    return this.http.post(`${this.emailUrl}sendContactUs`, payload);
  }

  forgetPassword(payload: any) {
    return this.http.post(`${this.emailUrl}forgetpassword`, payload);
  }

  resetPassword(payload: any) {
    return this.http.post(`${this.baseUrl}ForgetPassword/PasswordAction`, payload);
  }

  handleError(error: any): string {
    if (error.error?.message) {
      return error.error.message;
    } else if (error.message) {
      return error.message;
    } else {
      return 'An unexpected error occurred. Please try again.';
    }
  }

  getFareRule(payload: any) {
    return this.http.post(`${this.baseUrl}FareRules/GetFareRules`, payload);
  }
} 